import { AuthBrandLogo } from '../../features/auth/AuthBrandLogo';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthToken } from '../../features/auth/useAuthToken';
import { brandConfig } from '../../config/brands';
import './OrganizationCreatedPage.css';

export default function OrganizationCreatedPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setToken } = useAuthToken();
  const organizationName = location.state?.organizationName || '組織';
  const token = location.state?.token;

  useEffect(() => {
    // 新しいトークンを適用
    if (token) {
      setToken(token);
    }
  }, [token, setToken]);

  // GTM dataLayer イベント送信（Google広告CV計測用）
  // PII (組織名等) は GA4/Google Ads へ送らないため event 名のみを積む。
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'organization_created',
    });
  }, []);

  const handleStartUsing = () => {
    // トークンが適用されるまで少し待機してから遷移
    setTimeout(() => {
      navigate('/', { replace: true });
    }, 300);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <AuthBrandLogo />
        <div className="auth-card">
          <div className="auth-header">
            <img src="/check_2_green.svg" alt="完了" className="success-check-icon" />
            <h1 className="auth-title">組織の作成が完了しました</h1>
            <p className="auth-subtitle">
              {organizationName} の作成に成功しました
            </p>
          </div>

          <div className="auth-content">
            <div className="success-message">
              <p>
                組織が正常に作成されました。
                <br />
                あなたは自動的に管理者として登録されています。
              </p>
              <p>
                これで{brandConfig.serviceName}のすべての機能をご利用いただけます。
              </p>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn btn-primary btn-large"
                onClick={handleStartUsing}
              >
                利用を開始する
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
